/**
 * A barra do RODAPÉ: quanto falta para a próxima coleta do Oracle.
 *
 * Mesma linguagem da barra de rotação do topo — 4 px, sem texto nenhum —, e por
 * isso ninguém precisa aprender o que ela é: a de cima conta a troca de tela, a
 * de baixo conta a chegada de número novo. Foi pedida assim, "visível e fácil de
 * identificar sem ter escrita".
 *
 * A cor é a da meta (verde), e não o âmbar da rotação, de propósito: são duas
 * contagens diferentes acontecendo ao mesmo tempo na mesma tela, e a cor é o que
 * as distingue de longe.
 *
 * Ela ESVAZIA ao chegar em 100 % e começa de novo, porque o reinício é o dado:
 * barra cheia parada significaria coleta atrasada, e é exatamente o que a sala
 * precisa notar sem ninguém explicar.
 */

type Props = {
  /** Quanto do ciclo já passou, em porcentagem. */
  progresso: number
  /** O ciclo medido, em segundos. Vai só para o `title` e o `aria-label`. */
  intervaloSeg: number
}

export function BarraDaColeta({ progresso, intervaloSeg }: Props) {
  /* Largura em `style` porque é VALOR, não layout — igual à barra de rotação.
     O recorte em 0–100 protege de progresso fora da escala. */
  const largura = `${Math.min(Math.max(progresso, 0), 100)}%`
  const faltam = Math.max(Math.ceil(intervaloSeg * (1 - progresso / 100)), 0)

  return (
    <div
      className="barra-coleta"
      /* O texto existe para quem chega perto da tela e para leitor de tela; no
         telão, a informação é a barra. */
      title={`próxima leitura do ERP em ${faltam} s (ciclo de ${intervaloSeg} s)`}
      role="progressbar"
      aria-label="tempo até a próxima leitura do ERP"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progresso)}
    >
      <i style={{ width: largura }} />
    </div>
  )
}
